import { AutoCompleteStateless, DataSourceItem } from '@lendi-ui/auto-complete';
import getColour from '@lendi-ui/commons/colours';
import Field from '@lendi-ui/field';
import Search from '@lendi-ui/icon/Search';

import { FieldLabel } from '../../_common/FieldLabel';
import { FieldWrapper, Prefix } from '../../_common/style';
import { CommonFieldProps } from '../../_common/types';

export interface AutoCompleteInputFieldProps extends Omit<CommonFieldProps, 'name'> {
  dataSource: DataSourceItem[];
  onChange?: (value: string) => void;
  onReset?: () => void;
  value?: string;
  handleSelectedItem?: (value: DataSourceItem) => void;
  isFullWidth?: boolean;
  placeholder?: string;
  setValueOnUserTyping?: boolean;
  isDisabled?: boolean;
  backupOption?: DataSourceItem;
}

const SearchIcon = () => (
  <Prefix>
    <Search color={getColour('text', 'subtle')} height="24px" width="24px" />
  </Prefix>
);

const AutoCompleteInputField = (props: AutoCompleteInputFieldProps) => {
  const { handleSelectedItem, isOptional, label, labelAfter, subLabel, ...otherProps } = props;

  return (
    <FieldWrapper>
      <FieldLabel label={label} labelAfter={labelAfter} subLabel={subLabel} isOptional />
      <Field>
        <AutoCompleteStateless
          data-component="auto-complete"
          size="md"
          before={<SearchIcon />}
          onSelectItem={props.handleSelectedItem}
          {...otherProps}
          value={props.value}
          onChange={(e) => props.onChange && props.onChange(e.target.value)}
          onReset={props.onReset}
        />
      </Field>
    </FieldWrapper>
  );
};

export default AutoCompleteInputField;
